import React, { memo, useState } from "react";
import { useDispatch } from "react-redux";
import { DataTable, Icon, Modal } from "../../widgets";
import { toDisplayDateTimeString } from "../../../helpers/moment-ex";
import { Unit } from "../../../helpers/unit";
import TareForm from "./TareForm";
import { deleteTareLoad } from "../../../actions/load";

const TareHistoryRow = ({
  data,
  index,
  getTareHistory,
  nonEmptyColumns,
  tareLoadParamsList,
}) => {
  const unit = Unit.getInstance();
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const dispatch = useDispatch();

  const isWebfmLoad =
    data.hasOwnProperty("meta_data") &&
    data.meta_data.hasOwnProperty("location") &&
    !data.meta_data.location.latitude
      ? true
      : false;

  const {
    source_equipment_group_name,
    source_operator_name,
    target_equipment_group_name,
    operator_name,
    offload_geo_shape_name,
    offload_geo_storage_location_name,
    load_capacity,
    load_date,
    load_activity_uuid,
    crew_name,
    field_geo_shape_name,
    pipe,
    notes,
    load_params,
    light_weight,
    load_gross_weight,
    field_geo_shape_properties,
  } = data;
  const { division: divisionCode, area: areaCode, unit: unitCode } =
    field_geo_shape_properties || {};
  const hasValue = (value) =>
    value ? value : <span className="text-danger">Unknown</span>;

  const isNonEmptyColumn = (columnName) => nonEmptyColumns.includes(columnName);
  const handleDelete = () =>
    dispatch(deleteTareLoad({ load_activity_uuid }, () => getTareHistory()));

  return (
    <>
      <DataTable.Row
        style={{ backgroundColor: isWebfmLoad ? "#e2ffe9" : null }}
      >
        <DataTable.Cell>{index}</DataTable.Cell>
        {isNonEmptyColumn("crew_name") && (
          <DataTable.Cell>{hasValue(crew_name)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("field_geo_shape_name") && (
          <DataTable.Cell>{hasValue(field_geo_shape_name)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("source_equipment_group_name") && (
          <DataTable.Cell>
            {hasValue(source_equipment_group_name)}
          </DataTable.Cell>
        )}
        {isNonEmptyColumn("source_operator_name") && (
          <DataTable.Cell>{hasValue(source_operator_name)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("target_equipment_group_name") && (
          <DataTable.Cell>
            {hasValue(target_equipment_group_name)}
          </DataTable.Cell>
        )}
        {isNonEmptyColumn("operator_name") && (
          <DataTable.Cell>{hasValue(operator_name)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("offload_geo_shape_name") && (
          <DataTable.Cell>{hasValue(offload_geo_shape_name)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("offload_geo_storage_location_name") && (
          <DataTable.Cell>
            {hasValue(offload_geo_storage_location_name)}
          </DataTable.Cell>
        )}
        {isNonEmptyColumn("pipe") && (
          <DataTable.Cell>{hasValue(pipe)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("notes") && (
          <DataTable.Cell>{hasValue(notes)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("load_gross_weight") && (
          <DataTable.Cell>{unit.toWeight(load_gross_weight, 2)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("load_capacity") && (
          <DataTable.Cell>{unit.toWeight(load_capacity, 2)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("light_weight") && (
          <DataTable.Cell>{unit.toWeight(light_weight, 2)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("load_date") && (
          <DataTable.Cell>
            {hasValue(toDisplayDateTimeString(load_date, false, false))}
          </DataTable.Cell>
        )}
        {isNonEmptyColumn("division") && (
          <DataTable.Cell>{hasValue(divisionCode)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("area") && (
          <DataTable.Cell>{hasValue(areaCode)}</DataTable.Cell>
        )}
        {isNonEmptyColumn("unit") && (
          <DataTable.Cell>{hasValue(unitCode)}</DataTable.Cell>
        )}
        {load_params
          ? Object.keys(load_params).map((key) => {
              const value = load_params[key] ? load_params[key] : "Unknown";
              return (
                <DataTable.Cell
                  key={key}
                  style={{ color: `${value === "Unknown" ? "red" : ""}` }}
                >
                  {value}
                </DataTable.Cell>
              );
            })
          : tareLoadParamsList && tareLoadParamsList.length > 0
          ? tareLoadParamsList.map((e, index) => (
              <DataTable.Cell
                key={`index_${e}${index}`}
                style={{ color: "red" }}
              >
                Unknown
              </DataTable.Cell>
            ))
          : null}

        <DataTable.Cell>
          <div className="tare-action d-flex">
            <Icon
              title={"Edit"}
              className="fa fa-pencil ml-2 cursor-pointer"
              onClick={() => setShowForm(true)}
            />
            <Icon
              title={"Delete"}
              className="fa fa-trash ml-2 cursor-pointer"
              onClick={() => setShowDeleteModal(true)}
            />
          </div>
        </DataTable.Cell>
      </DataTable.Row>

      <TareForm
        formType="edit"
        show={showForm}
        onHide={() => setShowForm(false)}
        load={data}
      />

      <Modal.Confirm
        className="modal-bordered"
        show={showDeleteModal}
        onConfirm={handleDelete}
        onHide={() => setShowDeleteModal(false)}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to delete?`}
      />
    </>
  );
};

export default memo(TareHistoryRow);